import { ModelResource } from './resource';
import { DeductionDocument } from '../models';

export class DeductionDocuments extends ModelResource<DeductionDocument> {
  model = DeductionDocument;

  resourcePath = 'v1/deductions/documents';

  async reprocess(id: string, deductionDocument?: DeductionDocument) {
    const response = await this.api.post(this.path(id, 'process'));

    if (deductionDocument) {
      deductionDocument.updateFromJson(response.data);
    } else {
      deductionDocument = DeductionDocument.fromJson(response.data);
    }

    return deductionDocument;
  }
}
